import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { SiteLayoutComponent } from './components/site-layout/site-layout.component';
import { OverviewComponent } from './components/overview/overview.component';
import { SearchResultComponent } from './components/search-result/search-result.component';
import { TopStationsComponent } from './components/radio/top-stations/top-stations.component';
import { MusicComponent } from './components/radio/music/music.component';
import { NewsComponent } from './components/radio/news/news.component';
import { SportsComponent } from './components/radio/sports/sports.component';
import { GenresComponent } from './components/radio/genres/genres.component';
import { CountriesComponent } from './components/radio/countries/countries.component';
import { AboutUsComponent } from './components/about-pages/about-us/about-us.component';
import { ImprintComponent } from './components/about-pages/imprint/imprint.component';
import { SignupComponent } from './components/signup/signup.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ConfirmRegistrationComponent } from './components/confirm-registration/confirm-registration.component';
import { LoginWrapperComponent } from './components/login-wrapper/login-wrapper.component';
import { ResetPasswordComponent } from './components/reset-password/reset-password.component';
import { ChangePasswordComponent } from './components/change-password/change-password.component';
import { PrivacyPolicyComponent } from './components/privacy-policy/privacy-policy.component';
import { TermsAndConditionsComponent } from './components/terms-and-conditions/terms-and-conditions.component';
import { TopPodcastsComponent } from './components/podcast/top-podcasts/top-podcasts.component';
import { PodcastDetailComponent } from './components/podcast/podcast-detail/podcast-detail.component';
import { PodcastGenresComponent } from './components/podcast/podcast-genres/podcast-genres.component';
import { PodcastCountriesComponent } from './components/podcast/podcast-countries/podcast-countries.component';
import { PodcastSearchResultComponent } from './components/podcast-search-result/podcast-search-result.component';
import { RadioDetailComponent } from './components/radio/radio-detail/radio-detail.component';

const routes: Routes = [
  {
    path: '',
    component: SiteLayoutComponent,
    children: [
      { path: '', component: OverviewComponent, pathMatch: 'full'},

      { path: 'suche/radio/:searchText', component: SearchResultComponent },
      { path: 'suche/podcast/:searchText', component: PodcastSearchResultComponent },
      { path: 'top-sender', component: TopStationsComponent },

      { path: 'musik/:id', component: MusicComponent },
      { path: 'musik', component: MusicComponent },

      { path: 'nachrichten/:id', component: NewsComponent },
      { path: 'nachrichten', component: NewsComponent },

      { path: 'sport/:id', component: SportsComponent },
      { path: 'sport', component: SportsComponent },

      { path: 'genre/:id', component: GenresComponent },
      { path: 'genre', component: GenresComponent },

      { path: 'laender/:id', component: CountriesComponent },
      { path: 'laender', component: CountriesComponent },

      { path: 'top-podcasts', component: TopPodcastsComponent },

      { path: 'podcast-genre/:id', component: PodcastGenresComponent },
      { path: 'podcast-genre', component: PodcastGenresComponent },

      { path: 'podcast-laender/:id', component: PodcastCountriesComponent },
      { path: 'podcast-laender', component: PodcastCountriesComponent },

      { path: 'podcast/:id', component: PodcastDetailComponent },
      { path: 'radio/:name', component: RadioDetailComponent },

      { path: 'ueber-uns', component: AboutUsComponent },
      { path: 'impressum', component: ImprintComponent },
      { path: 'datenschutz', component: PrivacyPolicyComponent }
    ]
  },
  { path: 'registrieren', component: SignupComponent },
  { path: 'login', component: LoginWrapperComponent },
  { path: 'confirm-registration', component: ConfirmRegistrationComponent },
  { path: 'reset-password', component: ResetPasswordComponent },
  { path: 'change-password', component: ChangePasswordComponent },
  { path: 'terms-and-conditions', component: TermsAndConditionsComponent },
  { path: 'not-found', component: NotFoundComponent },
  { path: '**', redirectTo: 'not-found' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { enableTracing: false })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
